<template>
  <div v-if="!isCommandRunner">
    <CountBadge
      v-if="notificationsCount"
      :ariaLabel="`Alerts Badge shows ${notificationsCount} notifications.`"
      :data-test-id="$testId('notification')"
      isFixed
      isTiny
      :offsetX="50"
      status="error"
    >
      <IconButton
        :class="$style.button"
        :data-test-id="$testId('button')"
        hasNoBackground
        icon="notifications"
        text="Alerts"
        type="secondary"
        @click="handleClick"
      />
    </CountBadge>
    <IconButton
      v-else
      :class="$style.button"
      :data-test-id="$testId('button')"
      hasNoBackground
      icon="notifications"
      text="Alerts"
      type="secondary"
      @click="handleClick"
    />
  </div>
</template>

<script>
import { CountBadge, IconButton } from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';
import Util from 'client/util/Util';

export default {
  name: 'HeaderItemNotifications',

  Util,

  components: {
    CountBadge,
    IconButton,
  },

  props: {
    notificationsCount: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters('SettingsModule', ['isCommandRunner']),
  },

  methods: {
    handleClick() {
      this.$emit('click');
      this.$options.Util.redirect('#/notifications');
    },
  },
};
</script>

<style scoped module>
.button {
  --icon-button-spacing: var(--jc-spacer-small);
}
</style>
